export default class Common {
    static setData (name, data) {
        let dataStr = null
        if (typeof data === 'object') {
            dataStr = JSON.stringify(data)
        }
        if (typeof data === 'string' || typeof data === 'number') {
            dataStr = data.toString()
        }
        if (dataStr) {
            localStorage.setItem('emis-' + name, dataStr)
        }
    }

    static getData (name) {
        let data = localStorage.getItem('emis-' + name)
        if (data) {
            try {
                data = JSON.parse(data)
            } catch (e) {
            }
            return data
        }
    }

    static removeData (name) {
        localStorage.removeItem('emis-' + name)
    }

    static correctDate (value, onInvalid) {
        if (value.constructor === Date) {
            return value
        }
        if (value.constructor === Number && value.toString() < 13) {
            value = value * 1000
        }
        const result = new Date(value)

        if (result.toString() === 'Invalid Date') {
            if (onInvalid) {
                return onInvalid()
            }
            return new Date()
        }

        return result
    }

    static formatDate (value, format = 'y-m-d h:i:s') {
        let date = this.correctDate(value)

        const zero = num => parseInt(num) < 10 ? '0' + num : num
        const contrast = {
            y: date.getFullYear(),
            m: zero(date.getMonth() + 1),
            d: zero(date.getDate()),
            h: zero(date.getHours()),
            i: zero(date.getMinutes()),
            s: zero(date.getSeconds())
        }

        for (let n in contrast) {
            format = format.replace(new RegExp(n, 'g'), contrast[n])
        }

        return format
    }

    static isDate (value) {
        return isNaN(value) && !isNaN(Date.parse(value))
    }

    static listTransToOptions (list, keyName, valueName) {
        const options = {}
        for (let item of list) {
            options[item[keyName]] = item[valueName]
        }
        return options
    }

    static deepCopy (obj) {
        return JSON.parse(JSON.stringify(obj))
    }

    static findParentVM (vm, name) {
        if (vm.$parent !== undefined) {
            if (vm.$parent.$options.name === name) {
                return vm.$parent
            }
            return this.findParentVM(vm.$parent, name)
        }
        return null
    }

    static findChildrenVM (vm, name) {
        let res = []
        for (let item of vm.$children) {
            if (item.$options.name === name) {
                res.push(item)
            } else {
                if (item.$children.length) {
                    res = res.concat(this.findChildrenVM(item, name))
                }
            }
        }
        return res
    }

    static appendOrRemove (list, item) {
        const index = list.indexOf(item)
        if (index < 0) {
            list.push(item)
        } else {
            list.splice(index, 1)
        }
    }
}



// WEBPACK FOOTER //
// ./src/comp/form/common.js